// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__r7bt0","search":"Settings_search__29dp3","filter":"Settings_filter__1_kxd"};